// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyAQg_cv3hEtLPz0nLIxwRhPZEi2Zd3Tupw",
    authDomain: "clone-ecca7.firebaseapp.com",
    projectId: "clone-ecca7",
    storageBucket: "clone-ecca7.appspot.com",
    messagingSenderId: "395330902044",
    appId: "1:395330902044:web:b755298c2f20040a3e67d9",
    measurementId: "G-JYDY3EEBKK"
  };
  const firebaseApp = firebase.initializeApp(firebaseConfig); //initilize the app
  const db=firebaseApp.firestore(); //database initilize
  const auth = firebase.auth();
  
  export {db,auth};